import type { CinemaPageResponse } from '../pages/cinema/models'

export const CmsCinemaElementKeys = [
    'name',
    'urlSegment',
    'url',
    'nodeId',
    'alias',
    'createDate',
    'updateDate',
    'versions',
    'addressLine1',
    'addressLine2',
    'addressLine3',
    'postCode',
    'longitude',
    'latitude',
    'sitePickerCinemaAttributes',
    'vistaCinema',
    'foodAndBeverageEnabled',
    'filmAndExperienceShowtimePickerCinemaSubtitle',
    'cinemaMapURL',
] as const

export type CmsCinemaElement = Pick<CinemaPageResponse, (typeof CmsCinemaElementKeys)[number]>
